import React from "react";
import styled from "styled-components";
import { ContentContainer as SharedContentContainer } from "./HXMobilePage.styles";
import Download from "@mui/icons-material/Download";
import Button from "@mui/material/Button";
import { FlexColumnDiv } from "./common.styles";
export const ContentContainer = styled(SharedContentContainer) `
    gap: 24px;
`;
export const DownloadButton = styled(Button).attrs({
    variant: "outlined",
    color: "primary",
    size: "medium",
    startIcon: React.createElement(Download),
}) `
    width: 100%;
`;
export const BillOfRightsPDFContainer = styled(FlexColumnDiv) `
    align-self: stretch;
    gap: 16px;
`;
